<template>
  <div>
    <!-- 外部参会人相关 -->
    <van-cell-group class="mar-top-10 mar-operate-btm">
      <van-cell :title="`填写${participantTitle}`" is-link @click="handleSheet()"></van-cell>
      <van-cell v-show="frequentUsers.length" :title="`选择历史${participantTitle}`"
                is-link @click="showFrequentUsers = true"></van-cell>
      <van-cell v-for="(user, idx) in thisData" :key="user.tel" center>
        <template #title>
          <span class="color-box mar-rgt-10"
                :style="`background-color:rgba(${user.headerColor || '200,201,204'},0.35)`">{{user.name[0]}}</span>
          <span class="custom-title">{{user.name}} - {{user.tel}}</span>
        </template>
        <template #right-icon>
          <i class="fa fa-pencil text-lg mar-rgt" @click="handleSheet(user, idx)"></i>
          <van-icon name="clear" class="text-lg" @click="removeUser(user)"></van-icon>
        </template>
      </van-cell>
    </van-cell-group>
    <!--<div v-else>
      <van-cell class="cell-btm-none mar-top-10" title="" @click="handleSheet()">
        <template #right-icon>
          <span>添加外部参会人 <i class="fa fa-plus-circle"></i></span>
        </template>
      </van-cell>
      <empty-notice :desc="'暂无外部参会人'"></empty-notice>
    </div>-->

    <!--<div v-show="hasChanged" class="fixed-btm-box bord-top">
      <div class="pull-right pad-all-10">
        <van-button type="primary" size="small" @click="handleBack('users')">确定修改</van-button>
      </div>
    </div>-->

    <van-action-sheet v-model="showSheet" :title="forAdd?`添加${participantTitle}`:`修改${participantTitle}`">
      <van-form label-align="right" label-width="80" @submit="onSubmit">
        <van-field v-for="ele in sheetFields" :key="ele.key"
                   v-model="sheetDoc[ele.key]" :label="ele.label" :rules="sheetDocRules[ele.key] || []"
                   :name="ele.key" :placeholder="(ele.required ?'必填，':'')+'请输入'+ele.label"></van-field>
        <div class="mar-all">
          <van-button type="primary" block size="small" @click="">暂存</van-button>
        </div>
      </van-form>
    </van-action-sheet>

    <van-action-sheet v-model="showFrequentUsers" :title="`历史${participantTitle}`">
      <checkbox-group v-bind="frequentUserInfo" class="pad-btm"
                      @change-ids="changeUsers($event)">
      </checkbox-group>
    </van-action-sheet>

    <!--<back-route-hdr :back-mode="'func'" :cur-hash="'v-detail'"
                    @handle-back="handleBack()"></back-route-hdr>-->
  </div>
</template>

<script>
  import {commonConfig, formTitleCfg} from "../../../../../config/common";
  import CheckboxGroup from "../../../components/CheckboxGroup";
  import {frontConfirm} from "../../../../../tools/utils";
  import {account} from "../../../../../server";

  const basicDoc = {
    name: "",
    tel: "",
    email: "",
    company: "",
    position: "",
    licensePlateNumber: "",
    needNotification: false,  // 是否需要邮件、短信等通知
  };
  export default {
    components: {
      CheckboxGroup
    },
    props: {
      curData: Array,
    },
    data() {
      return {
        frequentUsers: [],  // 常用参会人
        showFrequentUsers: false,

        // thisData: [],
        showSheet: false,
        sheetDoc: {...basicDoc},
        // 输入框配置
        sheetFields: Object.keys(formTitleCfg.outsideParticipant).map(k => ({
          key: k,
          label: formTitleCfg.outsideParticipant[k],
          required: ['name', 'tel'].includes(k)
        })),
        forAdd: false,
        telReg: commonConfig.telReg,
        emailReg: commonConfig.emailReg,
      }
    },
    computed: {
      participantTitle() {
        return this.$store.state.formTitles.outsideParticipant
      },
      // hasChanged() {
      //   return JSON.stringify(this.curData) !== JSON.stringify(this.thisData)
      // },

      // 输入规则验证
      sheetDocRules() {
        return {
          name: [{required: true, message: '请输入姓名'}],
          tel: [{pattern: this.telReg, required: true, message: '请输入正确手机号码'}],
          email: [{
            validator: (val) => {
              if (val) return this.emailReg.test(val);
              return true
            }, required: false, message: '请输入正确邮箱'
          }],
        }
      },
      // 处理常用参会人信息
      frequentUserInfo() {
        return {
          list: this.frequentUsers.map(e => ({
            ...e,
            id: e.tel,
            name: `${e.name} - ${e.tel}`
          })),
          selectedIds: this.thisData.map(e => e.tel),
        }
      },
      thisData: {
        get() {
          return this.curData || []
        },
        set(arr) {
          // console.log(arr)
          this.$emit('change-data', arr)
        },
      }
    },
    watch: {
      showSheet(val) {
        if (val) return;
        this.sheetDoc = {...basicDoc}
      }
    },
    created() {
      this.getFrequentUsers();
    },
    methods: {
      getFrequentUsers() {
        account.frequentUser(this).then(({searchFrequentUserList: data = {}}) => {
          this.frequentUsers = (data.userEdges || []).map(e => ({...e.user}))
        }).catch(err => {
        })
      },
      removeUser(user) {
        frontConfirm({msg: `是否确认删除【${user.name} - ${user.tel}】？`}, () => {
          const idx = this.thisData.findIndex(e => e.userId === user.userId);
          this.thisData.splice(idx, 1);
          this.thisData = [].concat(this.thisData)
        })
      },
      handleSheet(ele, idx) {
        if (ele) {
          this.sheetDoc = {...ele, cnt: idx + 1};
          this.forAdd = false
        } else {
          this.forAdd = true
        }
        this.showSheet = true
      },
      onSubmit(info) {
        // console.log(info);
        const cIdx = this.sheetDoc.cnt && (this.sheetDoc.cnt - 1);

        const idx = this.thisData.findIndex(e => e.tel === info.tel);
        if (~idx && (!this.sheetDoc.cnt || (idx !== cIdx))) {
          vtToast(`手机号码【${info.tel}】客户已添加`);
          return
        }
        if (this.sheetDoc.cnt) {
          delete this.sheetDoc.cnt;
          if (JSON.stringify(this.thisData[cIdx]) !== JSON.stringify(this.sheetDoc)) {
            this.thisData[cIdx] = this.sheetDoc;  // 含 headerColor
            this.thisData = [].concat(this.thisData)  // 触发 watcher
          }
        } else {
          this.thisData = this.thisData.concat(info)
        }
        this.showSheet = false;
      },
      changeUsers(ids) {
        // console.log(ids);
        this.thisData = ids.map(id => {
          return this.thisData.find(i => i.tel === id) || this.frequentUsers.find(i => i.tel === id)
        });
      },
      handleBack(type) {
        let data;
        switch (type) {
          case 'frequent':
            this.showFrequentUsers = false;
            return;
          case 'users':
            data = {users: this.thisData};
            break;
          default:
        }
        this.$emit('change-info', data)
      },
    }
  }
</script>

<style scoped>
</style>
